import React, { useState, useEffect } from "react";

import { CardCarousel } from "Components/molecules/CardCarousel";
import { rssAdapter } from "shared/adapters/rssAdapter";
import { useRssFeed } from "shared/hooks/useRssFeed";

import {
  CardsWrapperMobile,
  CarouselWrapperMobile,
  TrackMobile,
} from "./styles";

export const CarouselMobile: React.FC = () => {
  const { data: rawData, loading, error } = useRssFeed();
  const items = rssAdapter(rawData);

  const itemsPerView = 1;
  const [startX, setStartX] = useState<number | null>(null);
  const [isDragging, setIsDragging] = useState(false);
  const [offset, setOffset] = useState(0);
  const itemWidth = 18.05 * 16; // Largura do card (17.25rem) + gap (0.8rem)
  const totalItems = items.length;

  // Gerar itens duplicados para continuidade
  const infiniteItems = [
    ...items.slice(-itemsPerView), // Últimos itens (antes do primeiro)
    ...items,
    ...items.slice(0, itemsPerView), // Primeiros itens (depois do último)
  ];

  useEffect(() => {
    setOffset(itemsPerView * itemWidth); // Centraliza no primeiro item duplicado
  }, [itemWidth]);

  const handleTouchStart = (e: React.TouchEvent) => {
    setStartX(e.touches[0].clientX);
    setIsDragging(true);
  };

  const handleTouchMove = (e: React.TouchEvent) => {
    if (startX !== null) {
      const deltaX = e.touches[0].clientX - startX;
      setOffset((prev) => prev - deltaX);
      setStartX(e.touches[0].clientX);
    }
  };

  const handleTouchEnd = () => {
    setIsDragging(false);

    // Ajusta a posição para alinhar ao item mais próximo
    const nearestItemIndex = Math.round(offset / itemWidth);
    const newOffset = nearestItemIndex * itemWidth;

    setTimeout(() => {
      if (nearestItemIndex >= totalItems + itemsPerView) {
        setOffset(itemsPerView * itemWidth);
      } else if (nearestItemIndex < itemsPerView) {
        setOffset(totalItems * itemWidth);
      } else {
        setOffset(newOffset);
      }
    }, 300);
  };

  if (loading) return <p></p>;
  if (error) return <p>Error loading RSS feed.</p>;
  if (!items || items.length === 0) return <p>No data available.</p>;

  return (
    <CarouselWrapperMobile
      onTouchStart={handleTouchStart}
      onTouchMove={handleTouchMove}
      onTouchEnd={handleTouchEnd}
    >
      <CardsWrapperMobile>
        <TrackMobile offset={offset} isDragging={isDragging}>
          {infiniteItems.map((card, index) => (
            <CardCarousel
              key={index}
              {...card}
              desktopVariant
              onCLick={() => window.open(card.link, "_blank")}
            />
          ))}
        </TrackMobile>
      </CardsWrapperMobile>
    </CarouselWrapperMobile>
  );
};
